// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"b076384d","340":"60283396","709":"02216561"}[chunkId] + ".chunk.js";
};